import { MessageBox } from 'element-ui';

export function confirm(
    content,
    title = '提示',
    confirmButtonText = '确定',
    cancelButtonText = '取消',
    type = 'warning'
) {
    return MessageBox.confirm(content, title, {
            confirmButtonText,
            cancelButtonText,
            type
        })
        .then(() => {
            return true;
        })
        .catch(() => {
            return false;
        });
}

export default {
    confirm
};


// WEBPACK FOOTER //
// ./src/common/messageBox.js